import type { RouteObject } from '@suntex.core/nav';
import { Outlet } from '@suntex.core/nav';
import { isTeamLeader } from '@suntex.fim/auth/react';
import { RequireAuth } from '@suntex.fim/framework';
import {
  ContentLibraryPage,
  PlayerDashboard,
  PlayerProvider,
} from '@suntex.fim/player';

import { PREVIEW_ROUTE } from '../const';

/**
 * The `play` child route for `/team/:teamId`: only the team's own leader can
 * play; other logins are redirected to the preview dashboard. Children are the
 * play dashboard (index) and the content library, sharing one PlayerProvider.
 */
export const teamPlayRoute: RouteObject = {
  path: 'play',
  element: (
    <RequireAuth requirement={isTeamLeader} forbiddenPath={PREVIEW_ROUTE} />
  ),
  children: [
    {
      element: (
        <PlayerProvider>
          <Outlet />
        </PlayerProvider>
      ),
      children: [
        { index: true, Component: PlayerDashboard },
        { path: 'content-library', Component: ContentLibraryPage },
      ],
    },
  ],
};
